import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { completeSignIn, isMagicLink } from '../lib/auth';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    void (async () => {
      if (!isMagicLink(window.location.href)) {
        await navigate('/login');
        return;
      }
      try {
        await completeSignIn(window.location.href);
        await navigate('/', { replace: true });
      } catch (err: unknown) {
        // Firebase wrappar blocking-trigger-fel som "auth/internal-error"
        // med JSON-payload i message:n. Extrahera det inre meddelandet.
        const raw = err instanceof Error ? err.message : 'Inloggning misslyckades';
        const match = /"message":"([^"]+)"/.exec(raw);
        setError(match?.[1] ?? raw);
      }
    })();
  }, [navigate]);

  if (error) {
    return (
      <main className="min-h-screen flex items-center justify-center p-4">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-serif text-red-600 mb-2">Kunde inte logga in</h1>
          <p className="text-ink-muted mb-4">{error}</p>
          <a href="/login" className="text-primary underline">Tillbaka till inloggning</a>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center">
      <Loader2 className="animate-spin text-primary" size={48} />
    </main>
  );
}
